import { render, staticRenderFns } from "./EduManage.vue?vue&type=template&id=7fa07eb4"
import script from "./EduManage.vue?vue&type=script&lang=js"
export * from "./EduManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports